import axios from 'axios';

export interface HaciendaActividadEconomica {
  estado: string;
  tipo: string;
  codigo: string;
  descripcion: string;
}

export interface HaciendaConsultByIdResponse {
  nombre: string;
  tipoIdentificacion: string;
  actividades?: HaciendaActividadEconomica[];
}

const HACIENDA_CONSULT_ID_API_URL = 'https://api.hacienda.go.cr/fe/ae';
const MIN_IDENTIFICATION_LENGTH = 9;

export const pickPrimaryActivityCode = (
  actividades?: HaciendaActividadEconomica[]
): string => {
  if (!actividades?.length) return '';

  const principalActiva = actividades.find(
    (a) => a.estado === 'A' && a.tipo === 'P' && a.codigo
  );
  if (principalActiva) return principalActiva.codigo;

  const anyActiva = actividades.find((a) => a.estado === 'A' && a.codigo);
  if (anyActiva) return anyActiva.codigo;

  return actividades[0]?.codigo ?? '';
};

export const fetchHaciendaConsultById = async (
  identification: string
): Promise<HaciendaConsultByIdResponse | null> => {
  const trimmedIdentification = identification.trim();

  if (trimmedIdentification.length < MIN_IDENTIFICATION_LENGTH) {
    return null;
  }

  try {
    const { data } = await axios.get<HaciendaConsultByIdResponse>(HACIENDA_CONSULT_ID_API_URL, {
      params: { identificacion: trimmedIdentification },
      timeout: 5000,
    });

    if (!data?.nombre || !data?.tipoIdentificacion) {
      return null;
    }
    return data;
  } catch (error) {
    console.warn('Hacienda consult by Id API lookup failed', error);
    return null;
  }
};
